import { useMemo } from "react";

export const setHeightAgGrid = (table, rows) => {

    let height = 0;
    if(rows){
        height = rows * 25;
    }else{
        if (table.Data.length > 0) {
            height = table.Data.length * 25;
        }else {
            height = 25;
        }
    }

    if(!table.hideFilter){
        height += 50;
    }
    if(!table.hideHeader){
        height += 35;
    }
    if(!table.hideFooter){
        height += 59;
    }else{
        if(rows < 3){
            height += 20;
        }
    }

    if( navigator.appVersion.indexOf("Win") !== -1){
        height += 20;
    }

    return height;
}


export const excelStyles = [
        {
            id: 'numberType',
            numberFormat: {
                format: '0',
            },
        },
        {
            id: 'currencyFormat',
            numberFormat: {
                format: '#,##0.00',
            },
            alignment: {
                horizontal: 'Right'
            },
        },
        {
            id: 'decimalFormat',
            numberFormat: {
                format: '#,##0.0000',
            },
        },
        {
            id: 'negativeInBrackets',
            numberFormat: {
                format: '$[blue] #,##0;$ [red](#,##0)',
            },
        },
        {
            id: 'booleanType',
            dataType: 'Boolean',
        },
        {
            id: 'stringType',
            dataType: 'String',
        },
        {
            id: 'dateType',
            dataType: 'DateTime',
        },
    ];